// =============================================================================
//  Copyright : 2022 semantics GmbH
//  Date      : $Date: 2025-03-25 16:17:33 +0100 (Tue, 25 Mar 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: a.hesse $
//  Revision  : $Rev: 151235 $
//  Purpose   : parts for vlm support
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {funcPart, loadLazy as ll} from 'uix/parts'

// #if process.env.UIX_PROD_CHUNKED === 'true'
const _VlmVisualEditor = ll(() => import(/* webpackChunkName: 'vlm' */ './visualedit'))
const _VlmCodeEditor = ll(() => import(/* webpackChunkName: 'vlm' */ './plainedit'))
const _VlmTextTickerEditor = ll(() => import(/* webpackChunkName: 'vlm' */ './ttselect'))
const _VlmDescriptionEditor = ll(() => import(/* webpackChunkName: 'vlm' */ './descriptionedit'))
const _VlmEngines = ll(() => import(/* webpackChunkName: 'vlm' */ './engines'))
// #endif

// #if process.env.UIX_PROD_CHUNKED !== 'true'
// import _VlmVisualEditor from './visualedit'
// import _VlmCodeEditor from './plainedit'
// import _VlmTextTickerEditor from './ttselect'
// import _VlmDescriptionEditor from './descriptionedit'
// import _VlmEngines from './engines'
// #endif

export const VlmVisualEditor = _VlmVisualEditor
export const VlmCodeEditor = funcPart({partStyle: {overflowX: 'hidden'}}, props => (
  <_VlmCodeEditor {...props} />
))
export const VlmTextTickerEditor = _VlmTextTickerEditor
export const VlmDescriptionEditor = _VlmDescriptionEditor
export const VlmEngines = _VlmEngines
